import React, { useState, useContext, useEffect } from "react";
import {
  Formik,
  Form as FormikForm,
  Field,
  ErrorMessage,
  useFormikContext,
} from "formik";
import { Form, Row, Col, Container } from "react-bootstrap";
import Button from "@mui/material/Button";
import { TextField, Select, InputLabel } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import * as Yup from "yup";
import { TaskContext } from "../components/TaskContext";
import { UserDataContext } from "../components/UserDataContext";
import axios from "axios";
import { API_URL } from "../App";
import { apiRequest } from "../components/Config";

const validationSchema = Yup.object().shape({
  nettoPerformer: Yup.number()
    .typeError("Wartość musi być liczbą")
    .required("Pole wymagane")
    .positive("Wartość musi być dodatnia")
    .max(999999.99, "Wartość nie może przekraczać 999999.99"),
  vat: Yup.number().required("Pole wymagane"),
  pzitbFactor: Yup.number()
    .required("Pole wymagane")
    .min(0, "Wartość musi być większa lub równa 0")
    .max(100, "Wartość nie może przekraczać 100"),
});

const initialValues = {
  nettoPerformer: "",
  vat: 23,
  pzitbFactor: 0,
};

const TaskSettlementsForm = () => {
  const { values, setFieldValue, handleSubmit, isSubmitting } =
    useFormikContext();
  const [total, setTotal] = useState(0);
  const [totalPZITB, setTotalPZITB] = useState(0);

  useEffect(() => {
    const nettoPerformer = parseFloat(values.nettoPerformer) || 0;
    const pzitb = parseFloat(values.pzitbFactor) || 0;
    const vat = parseFloat(values.vat) || 0;
    const totalValue =
      nettoPerformer +
      (nettoPerformer * vat) / 100 +
      (nettoPerformer * pzitb) / 100;
    setTotal(totalValue.toFixed(2));
    setTotalPZITB(((nettoPerformer * pzitb) / 100).toFixed(2));
  }, [values.nettoPerformer, values.vat, values.pzitbFactor]);

  return (
    <Container>
      <p className="p6">
        *** &nbsp;&nbsp;Dodanie wyceny do Zlecenia oznacza zgodę na uruchomienie
        zlecenia i przystąpienie do jego realizacji. &nbsp;&nbsp;***{" "}
      </p>
      <p>
        <b>Status zlecenia zostanie zmieniony na: "Realizacja zlecenia"</b>
      </p>

      <FormikForm onSubmit={handleSubmit}>
        <Row style={{ marginBottom: "20px" }}>
          <Col md="2">
            <Form.Group controlId="formSumNetto">
              <InputLabel>Netto - Wyk.</InputLabel>
              <Field
                as={TextField}
                name="nettoPerformer"
                type="number"
                onChange={(e) =>
                  setFieldValue(
                    "nettoPerformer",
                    parseFloat(e.target.value) || ""
                  )
                }
                fullWidth
              />
              <ErrorMessage
                name="nettoPerformer"
                component="div"
                className="text-danger"
              />
            </Form.Group>
          </Col>
          <Col md="2">
            <Form.Group controlId="formVat">
              <InputLabel>VAT</InputLabel>
              <Field as={Select} name="vat" fullWidth>
                <MenuItem value={23}>23%</MenuItem>
                <MenuItem value={8}>8%</MenuItem>
              </Field>
              <ErrorMessage
                name="vat"
                component="div"
                className="text-danger"
              />
            </Form.Group>
          </Col>
          <Col md="2">
            <Form.Group controlId="formPzitb">
              <InputLabel>Wsp. PZITB</InputLabel>
              <Field as={Select} name="pzitbFactor" fullWidth>
                {Array.from({ length: 101 }, (_, i) => (
                  <MenuItem key={i} value={i}>
                    {i}
                  </MenuItem>
                ))}
              </Field>
              <ErrorMessage
                name="pzitbFactor"
                component="div"
                className="text-danger"
              />
            </Form.Group>
          </Col>
        </Row>
        <Button type="submit" variant="outlined" disabled={isSubmitting}>
          Zapisz
        </Button>
        <hr />
        <p className="p3">Razem Brutto: {total}</p>
        <p className="p3">PZITB Netto: {totalPZITB}</p>
        <hr></hr>
      </FormikForm>
    </Container>
  );
};

const TaskSettlementsAdd = ({ addedData1 }) => {
  const { taskId } = useContext(TaskContext);
  const { userData } = useContext(UserDataContext);
  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    values["taskId"] = taskId;
    //console.log("Form data submitted:", values);
    try {
      const response = await apiRequest("updatetaskprice", "POST", values);
      //console.log("updatetaskprice:", response);
      setSubmitting(false);
      resetForm();
      addedData1();
    } catch (error) {
      console.error("Błąd podczas wysyłania formularza:", error);
      setSubmitting(false);
    }
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      <TaskSettlementsForm />
    </Formik>
  );
};

export default TaskSettlementsAdd;
